<form [formGroup]="form" (ngSubmit)="login($event)">
  <wb-error *ngIf="isError$ | async">
    {{ "error.credentials" | translate }}
  </wb-error>

  <mat-form-field>
    <input
      matInput
      formControlName="email"
      [placeholder]="'login.email' | translate"
    />
    <mat-error validation></mat-error>
  </mat-form-field>

  <mat-form-field>
    <input
      matInput
      formControlName="password"
      [placeholder]="'login.password' | translate"
      [type]="(hidePassword$ | async) ? 'password' : 'text'"
    />
    <button
      mat-icon-button
      matSuffix
      [attr.aria-label]="'Hide password'"
      [attr.aria-pressed]="hidePassword$"
      (click)="hidePassword$.next(!hidePassword$.value)"
      type="button"
    >
      <mat-icon
        *ngIf="form.value?.password"
        class="icon-password--size"
        [svgIcon]="getSvgIconPasswordValue(hidePassword$.value)"
      >
      </mat-icon>
    </button>
    <mat-error validation></mat-error>
  </mat-form-field>

  <wb-section
    direction="column"
    gap="small"
    justifyContent="center"
    alignItems="center"
  >
    <wb-button [isFullWidth]="true" type="submit">
      {{ "login.login" | translate }}
    </wb-button>
    <wb-link routerLink="/password">
      {{ "login.forgotPassword" | translate }}
    </wb-link>
  </wb-section>
</form>

<wb-loader [isActive]="(isLoading$ | async)!"></wb-loader>
